var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['sms-normal', _vm.disabled ? 'is-disabled' : ''],attrs:{"slot":"button","size":"small"},on:{"click":_vm.handleSendSms},slot:"button"},[_c('span',[_vm._v(_vm._s(_vm.smsTxt))])])
}
var staticRenderFns = []

export { render, staticRenderFns }